import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../services/firebase";
import { getAuth } from "firebase/auth";
import CreateEventSideBar from './CreateEventSideBar';
import CalendarEventDetails from './CalendarEventDetails';
import CalendarModal from '../CalendarModal';


const CalendarSideBar = React.forwardRef(({ isVisible, onClose }, ref) => {
  const hoursContainerRef = useRef(null);
  const eventColors = ["#ff6565", "#ba4a4a"];
const scrollToNow = () => {
  const today = new Date();
  setSelectedDate(today);
  if (hoursContainerRef.current) {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const position =
      hours * hourHeight + 
      (minutes / 60) * hourHeight + 
      (seconds / 3600) * hourHeight;
    hoursContainerRef.current.scrollTo({
      top: position - 30,
      behavior: "smooth",
    });
  }
};
const isToday = (date) => {
  const today = new Date();
  return (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  );
};
const [events, setEvents] = useState([]);
const [selectedDate, setSelectedDate] = useState(new Date());
const [showCreateEvent, setShowCreateEvent] = useState(false);
const [prefilledDateTime, setPrefilledDateTime] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isCalendarModalVisible, setIsCalendarModalVisible] = useState(false);
  useEffect(() => {
    if (!isVisible) {
      setShowCreateEvent(false);
      setPrefilledDateTime(null);
      setSelectedEvent(null);
      setSelectedDate(new Date());
    }
  }, [isVisible]);
  const handleEventClick = (event) => {
    setSelectedEvent(event);
  };
  const handleCloseDetails = () => {
    setSelectedEvent(null);
  };
const handleHourClick = (hour) => {
    const newDate = new Date(selectedDate);
    const [hourValue] = hour.split(":").map(Number);
    newDate.setHours(hourValue, 0, 0, 0);
    const endDate = new Date(newDate);
    endDate.setHours(hourValue + 1);
    setPrefilledDateTime({
        date: newDate,
        startTime: newDate,
        endTime: endDate,
    });
    setShowCreateEvent(true);
};
const hours = Array.from({ length: 24 }, (_, i) =>
`${String(i).padStart(2, "0")}:00`
);
const sidebarClass = `general-sidebar ${isVisible ? 'visible' : ''}`;
const event = {
title: "Evento de prueba",
startHour: 14,
startMinutes: 0,
endHour: 15,
endMinutes: 30,
};
const hourHeight = 60; 
const top =
event.startHour * hourHeight + (event.startMinutes / 60) * hourHeight + 10;
const height =
(event.endHour - event.startHour +
(event.endMinutes - event.startMinutes) / 60) *
hourHeight;
const [currentTimeTop, setCurrentTimeTop] = useState(0);
useEffect(() => {
const updateTime = () => {
const now = new Date();
const hours = now.getHours();
const minutes = now.getMinutes();
const seconds = now.getSeconds();
const position =
hours * hourHeight +
(minutes / 60) * hourHeight +
(seconds / 3600) * hourHeight; 
setCurrentTimeTop(position);
};
updateTime(); 
const interval = setInterval(updateTime, 60000); 
return () => clearInterval(interval);
}, []);
const changeDay = (days) => {
const newDate = new Date(selectedDate);
newDate.setDate(newDate.getDate() + days);
setSelectedDate(newDate);
};
const formatShortDate = (date) => {
const days = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
const months = [
"ene", "feb", "mar", "abr", "may", "jun",
"jul", "ago", "sept", "oct", "nov", "dic"
];
const dayName = days[date.getDay()];
const dayNum = date.getDate();
const month = months[date.getMonth()];
return `${dayName}, ${dayNum} ${month}`;
};
const formattedDate = formatShortDate(selectedDate);
const fetchEvents = async () => {
  try {
    const formatDateToLocal = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const dateStr = formatDateToLocal(selectedDate);
    const q = query(collection(db, "calendar"), where("date", "==", dateStr));
    const snapshot = await getDocs(q);
    const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setEvents(data);
  } catch (error) {
    console.error("Error obteniendo eventos:", error);
  }
};
useEffect(() => {
    fetchEvents();
}, [selectedDate]);
const groupOverlappingEvents = (events) => {
  const sorted = [...events].sort(
    (a, b) =>
      a.startHour * 60 + a.startMinutes -
      (b.startHour * 60 + b.startMinutes)
  );
  const result = [];
  let activeGroup = [];
  sorted.forEach((event) => {
    const start = event.startHour * 60 + event.startMinutes;
    activeGroup = activeGroup.filter((e) => {
      const eEnd = e.endHour * 60 + e.endMinutes;
      return eEnd > start;
    });
    activeGroup.push(event);
    const colIndex = activeGroup.length - 1;
    const totalCols = activeGroup.length;
    result.push({
      ...event,
      colIndex,
      totalCols,
    });
  });
  return result;
};
const groupedEvents = groupOverlappingEvents(events);
useEffect(() => {
  if (isVisible) {
    scrollToNow();
  }
}, [isVisible]);
const handleEdit = (event) => {
  setSelectedEvent(event);
  setShowCreateEvent(true);
};
const handleEventUpdated = (updatedEvent) => {
  setSelectedEvent(updatedEvent);
  fetchEvents();
};
const handleDeleteEvent = async (eventId) => {
  try {
    const idToken = await getAuth().currentUser.getIdToken();
    await fetch(`https://backend-288175208699.europe-west1.run.app/eliminar-calendar/${eventId}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${idToken}` },
    });
    setSelectedEvent(null);
    fetchEvents(); 
    handleCloseDetails()
  } catch (error) {
    console.error("Error eliminando evento:", error);
  }
};

const handleOpenCalendarModal = () => {
  setIsCalendarModalVisible(true);
};

const handleCloseCalendarModal = () => {
  setIsCalendarModalVisible(false);
};

const handleDateSelectionFromModal = (newDate) => {
  setSelectedDate(newDate); // Esta función es la clave, actualiza la fecha de la sidebar
  setIsCalendarModalVisible(false);
};
return (
  <div className={sidebarClass} ref={ref} >
    <AnimatePresence mode="wait">
      {selectedEvent ? (
        <CalendarEventDetails
          event={selectedEvent}
          onBack={handleCloseDetails}
          onEdit={handleEdit}
          onDelete={handleDeleteEvent}
        />
      ) : (
<motion.div
key="calendar"
initial={{ x: "100%" }}
animate={{ x: 0 }}
exit={{ x: "100%" }}
transition={{ duration: 0.15, ease: "easeInOut" }}
>
<div className="sidebar-header">
<h2 className="sidebar-header-title" style={{cursor:'default'}}>Calendario</h2>
<button onClick={onClose} className="sidebar-close-button">
&times;
</button>
</div>
<div className="date-header">
<div     className="date-text"
    onClick={handleOpenCalendarModal}
    style={{ cursor: "pointer" }}
  >
    {formattedDate}
  </div>
<div className="today-row">
            <span className="today-label" onClick={scrollToNow}>Hoy</span> {}
<div className="date-buttons">
  <button onClick={() => changeDay(-1)} className="arrow left"></button>
  <button onClick={() => changeDay(1)} className="arrow right"></button>
</div>
</div>
</div>
        <div className="hours-container" ref={hoursContainerRef} style={{ position: "relative" }}>
{hours.map((hour, i) => (
 <div key={i} className="hour-row" onClick={() => handleHourClick(hour)}>
<span className="hour-label">{hour}</span>
</div>
))}
{groupedEvents.map((event) => {
  const top =
    event.startHour * hourHeight +
    (event.startMinutes / 60) * hourHeight +
    10;
  const height =
    (event.endHour - event.startHour +
      (event.endMinutes - event.startMinutes) / 60) *
    hourHeight;
  const width = 100 / event.totalCols -7.5;
  const left = width * event.colIndex;
  const bgColor = eventColors[event.colIndex % eventColors.length]; 
  return (
    <div
      key={event.id}
      className="event"
      onClick={() => handleEventClick(event)}
      style={{
        top: `${top}px`,
        height: `${height}px`,
        left: `calc(${left}% + 40px)`,
        width: `calc(${width}% )`,
        position: "absolute",
        backgroundColor: bgColor,
        cursor: "pointer"
      }}
    >
      <span>{event.title}</span>
      <small>
        {event.startHour}:{String(event.startMinutes).padStart(2, "0")} -{" "}
        {event.endHour}:{String(event.endMinutes).padStart(2, "0")}
      </small>
      <span>{event.location}</span>
    </div>
  );
})}
{isToday(selectedDate) && (
  <div
    className="current-time-line"
    style={{
      position: "absolute",
      top: `${currentTimeTop}px`,
      left: "0",
      right: "0",
      height: "2px",
      backgroundColor: "#ff6565",
      zIndex: 5,
    }}
  />
)}
</div>
</motion.div>
      )}
    </AnimatePresence>
<AnimatePresence>
  {showCreateEvent && (
    <>
      {}
      <motion.div
        key="overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.4 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.15 }}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "black",
          zIndex: 40,
        }}
        onClick={() => {
          setShowCreateEvent(false);
          setPrefilledDateTime(null);
        }}
      />
      {}
      <CreateEventSideBar
        key="create-event"
        prefilledEvent={selectedEvent}
        onClose={() => {
          setShowCreateEvent(false);
          setPrefilledDateTime(null);
        }}
         onEventCreated={handleEventUpdated}
        prefilledDateTime={prefilledDateTime}
      />
    </>
  )}
</AnimatePresence>
 <CalendarModal
      isVisible={isCalendarModalVisible}
      onClose={handleCloseCalendarModal}
      onDateSelect={handleDateSelectionFromModal}
      showTimeInput={false}
    />
  </div>
);
});
export default CalendarSideBar;
